import { ACTIONS } from './connectionUtils'

interface template_day {
  date: number | null
  desayuno: number | null
  almuerzo: number | null
  comida: number | null
  merienda: number | null
  cena: number | null
  modified?: boolean
}

interface template {
  id: number
  name: string
  days: template_day[]
  default_template: boolean
  changed: boolean
}

interface TemplateResponse {
  success: boolean
  templates?: template[]
  error?: string
}

async function getTemplateInformation(user: string): Promise<TemplateResponse> {
  try {
    const response = await fetch('/api/template', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: TemplateResponse = await response.json()
    return data
  } catch (error) {
    console.error('Template error:', error)
    throw error
  }
}

async function saveNewTemplate(
  template: template,
  user: string
): Promise<TemplateResponse> {
  try {
    const response = await fetch('/api/template', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.INSERT,
        user,
        template,
      }),
    })
    const data: TemplateResponse = await response.json()
    return data
  } catch (error) {
    console.error('Template error:', error)
    throw error
  }
}

async function updateTemplate(
  template: template,
  user: string
): Promise<TemplateResponse> {
  try {
    const response = await fetch('/api/template', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.UPDATE,
        user,
        template,
      }),
    })
    const data: TemplateResponse = await response.json()
    return data
  } catch (error) {
    console.error('Template error:', error)
    throw error
  }
}

export { getTemplateInformation, saveNewTemplate, updateTemplate }

export type { TemplateResponse, template, template_day }
